import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BolsaService {
  public url: string = environment.url;

  constructor(
    private http: HttpClient
  ) { }

  getCities(id): Promise<any[]>{
    return new Promise<any[]>( (resolve, reject) => {
      this.http.get(`${this.url}/location/city/${id}`).subscribe((res: any) => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  }

  getSectors(id): Promise<any[]>{
    return new Promise<any[]>( (resolve, reject) => {
      this.http.get(`${this.url}/location/sector/${id}`).subscribe((res: any) => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  }

  getCountries(): Promise<any[]>{
    return new Promise<any[]>( (resolve, reject) => {
      this.http.get(`${this.url}/location/country`).subscribe((res: any) => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  }

  uploadPostulant(body, route = 'store'): Promise<any>{
    return new Promise<any>( (resolve, reject) => {
      this.http.post(`${this.url}/employments/${route}`, body).subscribe((res: any) => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  }

  getPostulant(): Promise<any>{
    return new Promise<any>( (resolve, reject) => {
      this.http.get(`${this.url}/employments/edit`).subscribe((res: any) => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  }

  getCategories(){
    return new Promise<any>( (resolve, reject) => {
      this.http.get(`${this.url}/employments/categories`).subscribe((res: any) => {
        resolve(res.data)
      }, err => {
        reject(err)
      })
    })
  }


  splitCategories(categories){
    categories = categories.map(value => {
      return value?.employment_categories_id || value?.id_categories;
    }, []);
    return categories;
  }

   getActualLocation(){
    return new Promise<string>(resolve => {
      this.http.get('https://api.ipregistry.co/?key=kxdw5xnvncddnxbl').subscribe((res: any) => {
        const country = res.location.country.name;
        resolve(country);
      })
    })
  }

  async setCountry(){
    try{
      const countries = await this.getCountries();
      const countryData: string = await this.getActualLocation();
      let savedCountry = localStorage.getItem('country');
      if(!savedCountry){
        const selectedCountry = countries.find(country => {
          const countryName = this.removeAccents(country.name);
          const countrySaved = this.removeAccents(countryData);
          if(countryName === countrySaved){
            return country
          }
        });
        if(selectedCountry){
          localStorage.setItem('country', String(countryData));
          localStorage.setItem('countryId', String(selectedCountry.id));
        }
      }
    }catch(err){
      console.error(err);
    }
  }

  removeAccents(str){
    const data = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return data.toLowerCase();
  } 
}
